import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=674170fc&scoped=true"
import script from "./message-item.vue?vue&type=script&lang=js"
export * from "./message-item.vue?vue&type=script&lang=js"
import style0 from "./message-item.vue?vue&type=style&index=0&id=674170fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674170fc",
  null
  
)

export default component.exports